export default "__VITE_ASSET__e6bf7602__"